// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Trust-space1-SkIOs {
	margin-bottom: 6px !important;
}

.Trust-space2-HJaEb {
	margin-bottom: 12px !important;
}

.Trust-space3-X75bv {
	margin-bottom: 18px !important;
}

.Trust-space4-waWRK {
	margin-bottom: 24px !important;
}

.Trust-space5-cUCP0 {
	margin-bottom: 30px !important;
}

.Trust-space6-QQd9V {
	margin-bottom: 36px !important;
}

.Trust-space7-e_u1N {
	margin-bottom: 42px !important;
}

.Trust-spaceTop8-OUIQu {
	margin-bottom: 48px !important;
}

.Trust-spaceTop1-r2rQJ {
	margin-top: 6px !important;
}

.Trust-spaceTop2-xjFpI {
	margin-top: 12px !important;
}

.Trust-spaceTop3-vjMUu {
	margin-top: 18px !important;
}

.Trust-spaceTop4-MPbvp {
	margin-top: 24px !important;
}

.Trust-spaceTop5-aUEog {
	margin-top: 30px !important;
}

.Trust-spaceTop6-oa2Xm {
	margin-top: 36px !important;
}

.Trust-spaceTop7-UgjD2 {
	margin-top: 42px !important;
}

.Trust-spaceTop8-OUIQu {
	margin-top: 48px !important;
}

.Trust-noMargin-z5hSd {
	margin: 0px !important;
}

.Trust-padding1-a7okH {
	padding-bottom: 6px !important;
}

.Trust-padding2-IXR_7 {
	padding-bottom: 12px !important;
}

.Trust-padding3-_KUuD {
	padding-bottom: 18px !important;
}

.Trust-padding4-o45S5 {
	padding-bottom: 24px !important;
}

.Trust-padding5-wmpz6 {
	padding-bottom: 30px !important;
}

.Trust-padding6-kJmjF {
	padding-bottom: 36px !important;
}

.Trust-padding7-R01Lr {
	padding-bottom: 42px !important;
}

.Trust-paddingTop1-gNPZy {
	padding-top: 6px !important;
}

.Trust-paddingTop2-S0M6o {
	padding-top: 12px !important;
}

.Trust-paddingTop3-rlZyd {
	padding-top: 18px !important;
}

.Trust-paddingTop4-tJJkl {
	padding-top: 24px !important;
}

.Trust-paddingTop5-xk_MU {
	padding-top: 30px !important;
}

.Trust-paddingTop6-gS5XL {
	padding-top: 36px !important;
}

.Trust-paddingTop7-LQmAX {
	padding-top: 42px !important;
}

.Trust-noPadding-QK28C {
	padding: 0px !important;
}

.Trust-textBold-ilyBb {
	font-weight: 500 !important;
}

.Trust-textBolder-VpAi8 {
	font-weight: 700 !important;
}

.Trust-textNormal-SOTmP {
	font-weight: normal !important;
}

.Trust-spaceBottom20-U5YLK {
	margin-bottom: 20px;
}

.Trust-spaceBottom10-SCrsW {
	margin-bottom: 10px;
}

.Trust-marginNone-LzMPx {
	margin: 0;
}

.Trust-spaceBottom15-TYs9H {
	margin-bottom: 15px;
}

.Trust-marginTopNone-aGoAA {
	margin-top: 0;
}

.Trust-spaceTop11-Hh3_G {
	margin-top: 11px;
}

.Trust-spaceTop21-LL1RV {
	margin-top: 21px;
}

.Trust-spaceTop20-oy1Pk {
	margin-top: 20px;
}

.Trust-spaceTop10-y3wr7 {
	margin-top: 10px;
}

/*New Design Text Colors */

.Trust-textDarkBlue-xIYoW {
	color: rgb(20, 39, 94) !important;
}

.Trust-textLightBlue-ls8w6 {
	color: rgb(57, 87, 106) !important;
}

.Trust-textLightSandleGreen-zPQL3 {
	color: rgb(76, 86, 41) !important;
}

.Trust-textLightBrown-IotFF {
	color: rgb(115, 79, 33) !important;
}

.Trust-textMediumMaroon-_PS5l {
	color: rgb(87, 37, 51) !important;
}

.Trust-textBrown-NKtFX {
	color: rgb(160, 47, 24) !important;
}

.Trust-textMaroon-ZbmiO {
	color: rgb(155, 49, 67) !important;
}

.Trust-textDarkBrown-NjZF1 {
	color: rgb(83, 18, 16) !important;
}

.Trust-textMediumBrown-w1cuq {
	color: rgb(142, 28, 10) !important;
}

.Trust-textSkyBlue-hgxjb {
	color: rgb(37, 117, 141) !important;
}

.Trust-textGray-qY2uy {
	color: rgb(77, 65, 51) !important;
}

/*************************verification Styles start******************************************/

.Trust-panelHeader-_KRE0 {
	border: 1px solid var(--primary-border);
	border-radius: 8px;
	padding: 22px 25px;
	margin-bottom: 30px;
}

.Trust-listLayout-UYaNd {
	margin-bottom: 0;
	padding-left: 0;
	list-style: none;
}

.Trust-description-Nopib {
	font-size: 14px;
	color: var(--secondary-foreground);
}

a {
	color: var(--primary-link-foreground);
	text-decoration: none;
}

a:hover {
	color: var(--primary-link-foreground);
	cursor: pointer;
}

.Trust-button-gHrP3 {
	white-space: normal;
	text-align: center;
	border: 1px solid;
	text-decoration: none !important;
	border-radius: 25px;
}

.Trust-btnverified-kOQog {
	border-color: #07B71D;
	background-color: #07B71D;
	color: var(--common-primary-white-foreground);
	padding: 9px 20px;
	border-radius: 22px;
}

.Trust-btnverified-kOQog:hover,
.Trust-btnverified-kOQog:focus,
.Trust-btnverified-kOQog:active,
.Trust-btnverified-kOQog:active:hover,
.Trust-btnverified-kOQog:active:focus {
	border-color: #07B71D;
	background-color: #07B71D;
	color: var(--common-primary-white-foreground);
}

.Trust-background-mHJv8 {
	padding: 28px 0 25px;
	border-bottom: 1px solid var(--primary-border);
	padding-bottom: 25px;
	margin: 0 !important;
}

.Trust-background-mHJv8:last-child {
	border-bottom: 1px solid transparent;
}

.Trust-displayFlex-Ho4fi {
	display: grid;
	grid-template-columns: 13% 70% 124px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}

.Trust-centerFlex-Cp7Zb {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}

.Trust-iconImageone-R96Xl {
	height: 50px;
}

.Trust-inlineFlex-jG6EV {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;

}

.Trust-textCenter-_QBH3 {
	text-align: right;
}

.Trust-flexEdit-erVVo {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

.Trust-editIconCss-RhHa2 {
	position: relative;
	top: -2px;
	margin-left: 2px;
}

.Trust-listingTitleText-WUUUL {
	margin: 0;
}

.Trust-verifiTitle-_55hc {
	margin-bottom: 6px;
}

.Trust-imgBorder-uZdyf {
	border: 1px solid var(--primary-border);
	border-radius: 50%;
	padding: 20px;
	width: 74px;
	height: 74px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.Trust-verifiBtn-V4x3k {
	background: transparent !important;
	border: inherit !important;
	padding: 0 0 0 4px;
	color: var(--common-primary-white-foreground) !important;
	opacity: 9 !important;
}

.Trust-noMargin-z5hSd {
	margin: 0;
}

.Trust-button-gHrP3 {
	background-color: transparent !important;
	border: inherit !important;
	color: var(--primary-link-foreground) !important;
}

.Trust-connectCss-j9Lq3 {
	margin-left: 6px;
}

.Trust-responsiveFlex-O5iP8 {
	text-align: right;
}

@media screen and (max-width:767px) {
	.Trust-responsiveCenter-r9Gj9 {
		text-align: center;
	}

	.Trust-responsiveFlex-O5iP8 {
		display: -webkit-inline-box;
		display: -ms-inline-flexbox;
		display: inline-flex;
		-webkit-box-pack: center;
		    -ms-flex-pack: center;
		        justify-content: center;
		margin-bottom: 8px;
	}

	.Trust-displayFlex-Ho4fi {
		grid-template-columns: 100%;
	}
}

/*************************verification Styles end******************************************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Trust/Trust.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA,6FAA6F;;AAC7F;CACC,uCAAuC;CACvC,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,qCAAqC;CACrC,qBAAqB;AACtB;;AAEA;CACC,qCAAqC;CACrC,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,iBAAiB;CACjB,gCAAgC;CAChC,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;CACzB,6CAA6C;CAC7C,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;;;;;CAKC,qBAAqB;CACrB,yBAAyB;CACzB,6CAA6C;AAC9C;;AAEA;CACC,oBAAoB;CACpB,8CAA8C;CAC9C,oBAAoB;CACpB,oBAAoB;AACrB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,aAAa;CACb,oCAAoC;CACpC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA;CACC,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;;AAExB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,WAAW;CACX,YAAY;CACZ,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,kCAAkC;CAClC,0BAA0B;CAC1B,kBAAkB;CAClB,wDAAwD;CACxD,qBAAqB;AACtB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,wCAAwC;CACxC,0BAA0B;CAC1B,gDAAgD;AACjD;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,kBAAkB;CACnB;;CAEA;EACC,2BAA2B;CAC5B;AACD;;AAEA,2FAA2F","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n/*************************verification Styles start******************************************/\n.panelHeader {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 8px;\n\tpadding: 22px 25px;\n\tmargin-bottom: 30px;\n}\n\n.listLayout {\n\tmargin-bottom: 0;\n\tpadding-left: 0;\n\tlist-style: none;\n}\n\n.description {\n\tfont-size: 14px;\n\tcolor: var(--secondary-foreground);\n}\n\na {\n\tcolor: var(--primary-link-foreground);\n\ttext-decoration: none;\n}\n\na:hover {\n\tcolor: var(--primary-link-foreground);\n\tcursor: pointer;\n}\n\n.button {\n\twhite-space: normal;\n\ttext-align: center;\n\tborder: 1px solid;\n\ttext-decoration: none !important;\n\tborder-radius: 25px;\n}\n\n.btnverified {\n\tborder-color: #07B71D;\n\tbackground-color: #07B71D;\n\tcolor: var(--common-primary-white-foreground);\n\tpadding: 9px 20px;\n\tborder-radius: 22px;\n}\n\n.btnverified:hover,\n.btnverified:focus,\n.btnverified:active,\n.btnverified:active:hover,\n.btnverified:active:focus {\n\tborder-color: #07B71D;\n\tbackground-color: #07B71D;\n\tcolor: var(--common-primary-white-foreground);\n}\n\n.background {\n\tpadding: 28px 0 25px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tpadding-bottom: 25px;\n\tmargin: 0 !important;\n}\n\n.background:last-child {\n\tborder-bottom: 1px solid transparent;\n}\n\n.displayFlex {\n\tdisplay: grid;\n\tgrid-template-columns: 13% 70% 124px;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.centerFlex {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n}\n\n.iconImageone {\n\theight: 50px;\n}\n\n.inlineFlex {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\n}\n\n.textCenter {\n\ttext-align: right;\n}\n\n.flexEdit {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.editIconCss {\n\tposition: relative;\n\ttop: -2px;\n\tmargin-left: 2px;\n}\n\n.listingTitleText {\n\tmargin: 0;\n}\n\n.verifiTitle {\n\tmargin-bottom: 6px;\n}\n\n.imgBorder {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 50%;\n\tpadding: 20px;\n\twidth: 74px;\n\theight: 74px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.verifiBtn {\n\tbackground: transparent !important;\n\tborder: inherit !important;\n\tpadding: 0 0 0 4px;\n\tcolor: var(--common-primary-white-foreground) !important;\n\topacity: 9 !important;\n}\n\n.noMargin {\n\tmargin: 0;\n}\n\n.button {\n\tbackground-color: transparent !important;\n\tborder: inherit !important;\n\tcolor: var(--primary-link-foreground) !important;\n}\n\n.connectCss {\n\tmargin-left: 6px;\n}\n\n.responsiveFlex {\n\ttext-align: right;\n}\n\n@media screen and (max-width:767px) {\n\t.responsiveCenter {\n\t\ttext-align: center;\n\t}\n\n\t.responsiveFlex {\n\t\tdisplay: inline-flex;\n\t\tjustify-content: center;\n\t\tmargin-bottom: 8px;\n\t}\n\n\t.displayFlex {\n\t\tgrid-template-columns: 100%;\n\t}\n}\n\n/*************************verification Styles end******************************************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Trust-space1-SkIOs`,
	"space2": `Trust-space2-HJaEb`,
	"space3": `Trust-space3-X75bv`,
	"space4": `Trust-space4-waWRK`,
	"space5": `Trust-space5-cUCP0`,
	"space6": `Trust-space6-QQd9V`,
	"space7": `Trust-space7-e_u1N`,
	"spaceTop8": `Trust-spaceTop8-OUIQu`,
	"spaceTop1": `Trust-spaceTop1-r2rQJ`,
	"spaceTop2": `Trust-spaceTop2-xjFpI`,
	"spaceTop3": `Trust-spaceTop3-vjMUu`,
	"spaceTop4": `Trust-spaceTop4-MPbvp`,
	"spaceTop5": `Trust-spaceTop5-aUEog`,
	"spaceTop6": `Trust-spaceTop6-oa2Xm`,
	"spaceTop7": `Trust-spaceTop7-UgjD2`,
	"noMargin": `Trust-noMargin-z5hSd`,
	"padding1": `Trust-padding1-a7okH`,
	"padding2": `Trust-padding2-IXR_7`,
	"padding3": `Trust-padding3-_KUuD`,
	"padding4": `Trust-padding4-o45S5`,
	"padding5": `Trust-padding5-wmpz6`,
	"padding6": `Trust-padding6-kJmjF`,
	"padding7": `Trust-padding7-R01Lr`,
	"paddingTop1": `Trust-paddingTop1-gNPZy`,
	"paddingTop2": `Trust-paddingTop2-S0M6o`,
	"paddingTop3": `Trust-paddingTop3-rlZyd`,
	"paddingTop4": `Trust-paddingTop4-tJJkl`,
	"paddingTop5": `Trust-paddingTop5-xk_MU`,
	"paddingTop6": `Trust-paddingTop6-gS5XL`,
	"paddingTop7": `Trust-paddingTop7-LQmAX`,
	"noPadding": `Trust-noPadding-QK28C`,
	"textBold": `Trust-textBold-ilyBb`,
	"textBolder": `Trust-textBolder-VpAi8`,
	"textNormal": `Trust-textNormal-SOTmP`,
	"spaceBottom20": `Trust-spaceBottom20-U5YLK`,
	"spaceBottom10": `Trust-spaceBottom10-SCrsW`,
	"marginNone": `Trust-marginNone-LzMPx`,
	"spaceBottom15": `Trust-spaceBottom15-TYs9H`,
	"marginTopNone": `Trust-marginTopNone-aGoAA`,
	"spaceTop11": `Trust-spaceTop11-Hh3_G`,
	"spaceTop21": `Trust-spaceTop21-LL1RV`,
	"spaceTop20": `Trust-spaceTop20-oy1Pk`,
	"spaceTop10": `Trust-spaceTop10-y3wr7`,
	"textDarkBlue": `Trust-textDarkBlue-xIYoW`,
	"textLightBlue": `Trust-textLightBlue-ls8w6`,
	"textLightSandleGreen": `Trust-textLightSandleGreen-zPQL3`,
	"textLightBrown": `Trust-textLightBrown-IotFF`,
	"textMediumMaroon": `Trust-textMediumMaroon-_PS5l`,
	"textBrown": `Trust-textBrown-NKtFX`,
	"textMaroon": `Trust-textMaroon-ZbmiO`,
	"textDarkBrown": `Trust-textDarkBrown-NjZF1`,
	"textMediumBrown": `Trust-textMediumBrown-w1cuq`,
	"textSkyBlue": `Trust-textSkyBlue-hgxjb`,
	"textGray": `Trust-textGray-qY2uy`,
	"panelHeader": `Trust-panelHeader-_KRE0`,
	"listLayout": `Trust-listLayout-UYaNd`,
	"description": `Trust-description-Nopib`,
	"button": `Trust-button-gHrP3`,
	"btnverified": `Trust-btnverified-kOQog`,
	"background": `Trust-background-mHJv8`,
	"displayFlex": `Trust-displayFlex-Ho4fi`,
	"centerFlex": `Trust-centerFlex-Cp7Zb`,
	"iconImageone": `Trust-iconImageone-R96Xl`,
	"inlineFlex": `Trust-inlineFlex-jG6EV`,
	"textCenter": `Trust-textCenter-_QBH3`,
	"flexEdit": `Trust-flexEdit-erVVo`,
	"editIconCss": `Trust-editIconCss-RhHa2`,
	"listingTitleText": `Trust-listingTitleText-WUUUL`,
	"verifiTitle": `Trust-verifiTitle-_55hc`,
	"imgBorder": `Trust-imgBorder-uZdyf`,
	"verifiBtn": `Trust-verifiBtn-V4x3k`,
	"connectCss": `Trust-connectCss-j9Lq3`,
	"responsiveFlex": `Trust-responsiveFlex-O5iP8`,
	"responsiveCenter": `Trust-responsiveCenter-r9Gj9`
};
module.exports = ___CSS_LOADER_EXPORT___;
